import { isEqual, without } from 'lodash-es'
import { useEffect, useMemo, useState } from 'react'

import { useETEditorFormikPoolingType } from 'services/event_types'

import { NEW_POSSIBLE_KINDS } from '../constants'
import { getIsAnyCollectiveUserPools } from '../utils'

export const useLocationSettings = (eventType, userPools, withIntegrationErrors, isManaged, hideErrors) => {
  const { isPoll, isGroup } = eventType
  const { isRoundRobin, isCollective, isCollectiveRoundRobin } = useETEditorFormikPoolingType()
  const [possibleKinds, setPossibleKinds] = useState(NEW_POSSIBLE_KINDS)
  const [showIntegrationErrors, setShowIntegrationErrors] = useState(withIntegrationErrors)

  const isCRRWithoutCollectivePools = useMemo(
    () => isCollectiveRoundRobin && !getIsAnyCollectiveUserPools(userPools),
    [isCollectiveRoundRobin, userPools]
  )

  useEffect(() => {
    let updatedPossibleKinds = NEW_POSSIBLE_KINDS
    let updatedShowIntegrationErrors = showIntegrationErrors

    if (isPoll || isGroup || isRoundRobin || isCRRWithoutCollectivePools) {
      updatedPossibleKinds = without(updatedPossibleKinds, 'ask_invitee', 'outbound_call')
    }
    if (isManaged || hideErrors) {
      updatedShowIntegrationErrors = false
    }
    if (!isEqual(updatedPossibleKinds, possibleKinds)) {
      setPossibleKinds(updatedPossibleKinds)
    }
    if (updatedShowIntegrationErrors !== showIntegrationErrors) {
      setShowIntegrationErrors(updatedShowIntegrationErrors)
    }
  }, [isPoll, isGroup, isRoundRobin, isCollective, isCollectiveRoundRobin, isManaged,
    hideErrors, possibleKinds, showIntegrationErrors, isCRRWithoutCollectivePools])

  return [possibleKinds, showIntegrationErrors]
}
